<template>
  <div>
    <b-table
      class="table-text"
      hover
      :items="houses"
      :fields="fields"
      fixed
      responsive
    >
      <template #cell(actions)="row">
        <b-button
          size="sm"
          @click="editHouse(row.item)"
          class="optionsButtonClient mr-3"
        >
          <b-icon icon="pencil-fill"></b-icon>
        </b-button>
        <b-button
          size="sm"
          @click="deleteHouse(row.item)"
          class="optionsButtonClient mr-3"
        >
          <b-icon icon="trash-fill"></b-icon>
        </b-button>
      </template>
    </b-table>
  </div>
</template>

<script>
import Vue from 'vue';
import ModalEditHouse from './ModalEditHouse.vue';
import ModalConfirmationDelete from '../ModalConfirmationDelete.vue';
import { RemoveHouse } from '../../services/House';
import showError from '../../utils/showError';

export default {
  data() {
    return {
      fields: [
        {
          key: 'house_name',
          label: 'Nome',
          thStyle: { background: '#BE8250', color: '#ffffff' },
        },
        {
          key: 'house_code',
          label: 'Código',
          thStyle: { background: '#BE8250', color: '#ffffff' },
          class: 'text-center',
        },
        {
          key: 'compound.product.type',
          label: 'Cogumelo',
          thStyle: { background: '#BE8250', color: '#ffffff' },
          class: 'text-center',
        },
        {
          key: 'compound.compound_number',
          label: 'Número do Composto',
          thStyle: { background: '#BE8250', color: '#ffffff' },
          class: 'text-center',
        },
        {
          key: 'actions',
          label: 'Ações',
          thStyle: { background: '#BE8250', color: '#ffffff' },
          class: 'text-center',
        },
      ],
      headVariant: 'dark',
    };
  },
  props: {
    houses: {
      type: Array,
      required: true,
    },
  },
  methods: {
    editHouse(house) {
      const modalEditHouse = new Vue({
        render(h) {
          return h(ModalEditHouse, {
            props: {
              house,
            },
          });
        },
      });
      modalEditHouse.$mount();

      modalEditHouse.$bvModal.show('modal-edit-casa');
    },
    deleteHouse(house) {
      const modalConfirmation = new Vue(ModalConfirmationDelete);
      modalConfirmation.$mount();
      modalConfirmation.$bvModal.show('modal-confirmation-delete');
      modalConfirmation.$on('exclusaoConfirmada', () => {
        RemoveHouse(house.id)
          .then(() => {
            this.$toasted.global.defaultSuccess();
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          })
          .catch(showError);
      });
    },
  },
};
</script>

<style scoped>
.table-text {
  font-family: 'Inter', sans-serif;
  color: #000;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.optionsButtonClient {
  background-color: transparent;
  border: none;
  outline: none;
  color: #615f5f;
}

.optionsButtonClient:focus {
  outline: none;
}
</style>
